import type { ICashbackClaimSummaryResources } from "./CashbackClaimSummary.Resources";

export const CashbackClaimSummaryResourcesEn: ICashbackClaimSummaryResources = {
    purchaseLabel: "Purchase: ",
};
